export function atSetVehicleType(state, { type }) {
  state.type = type;
}

export function atSetLicencePlateAndEmail(state, payload) {
  state.licencePlate = payload.licencePlate;
  state.email = payload.email;
}

export function flush(state) {
  state.type = null;
  state.licencePlate = null;
  state.email = '';
  state.duration = 1;
}
